import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../Services/auth.service';
import { CommonService } from '../../Services/common.service';

@Component({
  selector: 'app-change-pin-verify',
  standalone: false,
  templateUrl: './change-pin-verify.component.html',
  styleUrls: ['./change-pin-verify.component.scss']
})


export class ChangePinVerifyComponent implements OnInit {
  
  CardNumber:string="";
  DigitPin:string="";
  ExistingPin:string="";
  NewdigitPin:string="";

  

  constructor( public commonP: CommonService, public auth: AuthService, public _router: Router) { }

  ngOnInit(): void {
  }

 ChangeCardPinVerifyOTP(){
     this.commonP.presentLoading();
    this.auth.ChangeCardPinVerifyOTP('body',this.auth.accessToken).then((data:any)=>{
      if(data?.response?.code ==1){
      console.log(data,'ChangeCardPinVerifyOTP');
      this._router.navigateByUrl('/DashboardCreditCards');
      this.commonP.hideLoading();
      }
      else{
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('Sorry','Ok',this._router,data)
      }
    })
  }
}
